const locations = {
  toast: {
    error: {
      badResponse: '[Location] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Location] has been created successfully',
      },
      edit: {},
      delete: {
        default: '[Location] deleted successfully',
      },
    },
  },
  headerButtons: {
    create: {
      createBtn: 'Create',
    },

    import: 'Import',
  },

  deleteModal: {
    header: 'Delete Locations',
    body: 'You are about to delete {{num}} locations.',
  },

  printoutsModal: {
    title: 'Printouts PDF Export',
    description: 'Please select date range (maximum 31 days)',
    maxRangeError: 'Please select a range of 31 days or less',
    export: 'Export',
  },

  table: {
    filters: {
      type: 'Type',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
      printouts: 'Printouts',
    },
    moreActions: {
      showOnMap: 'Show On Map',
    },
    headers: {
      name: 'Name',
      type: 'Type',
      address: 'Address',
      lat: 'Latitude',
      lon: 'Longitude',
      locationTypes: {
        location: 'Location',
        inAndOut: 'In And Out',
        airport: 'Airport',
        facility: 'Facility',
      },
      wait: 'Wait',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createLocation: {
        title: 'Create',
      },

      updateLocation: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    addressInformation: {
      title: 'Address Information',
      name: 'Name',
      type: 'Type',
      wait: 'Wait',
      address: 'Address',
      locationTypes: {
        location: 'Location',
        inAndOut: 'In And Out',
        airport: 'Airport',
        facility: 'Facility',
      },
    },
    radius: {
      title: 'Address Matching Radius',
      toolTipInformation:
        'The radius in meters or feet (m/ft for metric/imperial) within which reservations are recognized as the location and or as wait-and-return.',
    },
    waitAndReturn: {
      title: 'Wait And Return',
      time: 'Waiting Time',
      timeDescription: 'The duration in minutes that a driver will wait between the outbound and return legs of a wait-and-return trip.',
    },
    advancedSettings: {
      consistentPassengerRouting: {
        title: 'Consistent Passenger Routing',
        toolTipInformation:
          'Ensures that the same group of passengers always follows the same route to and from the facility, optimizing travel efficiency and minimizing confusion.',
      },
      snapAddressWithinRadius: {
        title: 'Snap Address Within Radius',
        toolTipInformation: "When a pickup/dropoff is within location's radius, snaps to location's name & coordinates",
      },
      sameFlightNumber: {
        title: 'Same Flight Number',
        toolTipInformation: 'Bookings will be grouped together only if the flight number is the same.',
      },
      sameDriverForGroup: {
        title: 'Same Driver for Group',
        toolTipInformation:
          'Assigns the same driver to transport the group of passengers for both pick-up and drop-off, providing familiarity and consistency for passengers.',
      },
      overrideOptions: {
        bySystemSettings: 'By System Settings',
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      allowSharedRide: {
        title: 'Allow Shared Ride With Other Addresses',
        toolTipInformation:
          'When enabled, this setting allows shared rides to be grouped with bookings from other locations that have consistent routes. If disabled, only rides from the same location will be considered for grouping.',
      },
      tripBoardingTime: {
        title: 'Boarding Time',
        toolTipInformation: 'The time it takes to pick up a passenger on their stop (This parameter will impact overall trip duration)',
      },
      waitForBoardingTime: {
        title: 'Wait For Boarding Time',
        toolTipInformation: 'When reaching a stop, the driver will wait until the exact pick-up time, if needed.',
      },
      tripDropOffTime: {
        title: 'Drop-off Time',
        toolTipInformation: 'The time it takes to drop a passenger on their stop (This parameter will impact overall trip duration)',
      },
      rules: {
        header: 'Location / Profiles Rules',
        rule: 'Rule',
        profiles: 'Profiles',
        addNewRule: '+ Add Location / Profile Rule',
      },
      maxDropOffEarly: {
        title: 'Max Drop-off Early',
        toolTipInformation: 'Maximum number of minutes a driver can get early relative to the drop-off time set in the reservation',
      },
      maxDropOffDelay: {
        title: 'Max Drop-off Delay',
        toolTipInformation: 'Maximum number of minutes a driver can be late for the drop off time set in the reservation',
      },
      maxBoardingDelay: {
        title: 'Max Boarding Delay',
        toolTipInformation: 'Maximum number of minutes a driver can be late for the pickup time set in the reservation',
      },
      maxBoardingEarly: {
        title: 'Max Boarding Early',
        toolTipInformation: 'Maximum number of minutes a driver can get early relative to the pickup time set in the reservation',
      },
      maxTripDuration: {
        title: 'Max Trip Duration',
        toolTipInformation: 'Maximum duration of a trip in minutes',
      },
      maxSinglePassengerTime: {
        title: 'Max Single Passenger Trip Time',
        toolTipInformation: 'Maximum duration of a trip in minutes per passenger',
      },
    },
    advanced: {
      title: 'Advanced',
      addTime: {
        addTimeBtn: 'Add Time',
        name: 'Name',
        minutes: 'Minutes',
        enterMinutes: 'Enter minutes',
        enterName: 'Enter Name',
      },
    },
    map: {
      title: 'Map',
    },
    site: {
      title: 'Site',
    },

    info: {
      subLocations: {
        addSubLocationBtn: 'Add Terminal',
        header: 'Terminal',
        fields: {
          subLocation: 'Address',
          name: {
            label: 'Address Name',
            placeholder: 'Name',
          },
        },
      },
    },
  },

  update: {
    confirmButtonText: 'Update',
    formTabs: {
      info: 'Info',
      advancedSettings: 'Advanced Settings',
      history: 'History',
    },

    successToast: {
      message: 'Created! Location Updated Successfully.',
    },

    errorToast: {
      message: 'Error. Could Not Update Location.',
    },
  },

  create: {
    formTabs: {
      info: 'Info',
      advancedSettings: 'Advanced Settings',
    },
    successToast: {
      message: 'Created! Location created successfully.',
    },

    errorToast: {
      message: 'Error. Could not create location.',
    },
  },

  delete: {
    successToast: {
      message: 'Deleted! Location deleted successfully.',
    },

    errorToast: {
      message: 'Error. Could not delete location.',
    },
  },

  createModal: {
    title: 'Wait And Return',
    body: "You are about to designate this location as a 'Wait and Return' location. This will automatically apply the 'Wait & Return' setting to all future bookings at this location. Are you sure you want to proceed?",
  },
  enableLocationTypeModal: {
    title: 'Wait And Return',
    body: "You are about to enable the 'Wait and Return' setting. This will apply to all current and future bookings that qualify as 'Wait & Return.' Are you sure you want to proceed?",
  },
  disableLocationTypeModal: {
    title: 'Wait And Return',
    body: "You are about to disable the 'Wait and Return' setting. This will remove it from all current and future bookings identified as 'Wait & Return.' Are you sure you want to proceed?",
  },
  deleteLocationTypeModal: {
    title: 'You are about to delete {{count}} locations.',
    titleAll: 'You are about to delete all locations.',
    body: "These locations contain a 'Wait and Return' location. This will automatically apply the 'Wait & Return' setting to all future bookings at this location. Are you sure you want to proceed?",
  },
  updateLocationOfTypeLocationModal: {
    title: 'Wait And Return',
    body: "You are about to change this location to a 'Wait and Return' location. This will automatically apply the 'Wait & Return' setting to all future bookings at this location. Are you sure you want to proceed?",
  },
};

export default locations;
